import { render, staticRenderFns } from "./ZJXNSDMM.vue?vue&type=template&id=50da94f1&scoped=true"
import script from "./ZJXNSDMM.vue?vue&type=script&lang=js"
export * from "./ZJXNSDMM.vue?vue&type=script&lang=js"
import style0 from "./ZJXNSDMM.vue?vue&type=style&index=0&id=50da94f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da94f1",
  null
  
)

export default component.exports